module.exports = __webpack_public_path__ + "static/media/icono_configuracion_inicial.03c3a99f.svg";